import { http } from '@noor/api';
import { env } from '@noor/config';
import {
  foodOrderListSchema,
  foodOrderDetailSchema,
  type FoodOrderSearch,
  type CancelFoodOrder,
  type CreateTestFoodOrder,
} from '../model/schema';
const baseURL = env.VITE_EATS_API_URL;
const path = '/api/v1/admin/orders';
export function foodOrderQuery(params: FoodOrderSearch): Record<string, string | number> {
  const query: Record<string, string | number> = {
    'pagination.limit': params.limit,
    'pagination.offset': (params.page - 1) * params.limit,
    admin_filter: params.filter,
  };
  const scopeKey = {
    'by-merchant': 'merchant_id',
    'by-restaurant': 'restaurant_id',
    'by-user': 'user_id',
  }[params.scope];
  if (params.entityId) query[scopeKey] = params.entityId;
  if (params.source) query.problem_source = params.source;
  // The by-user endpoint does not accept search or date filters.
  if (params.scope !== 'by-user') {
    if (params.search) query.search = params.search;
    if (params.from)
      query.created_from = new Date(`${params.from}T00:00:00+05:00`).toISOString();
    if (params.to)
      query.created_to = new Date(`${params.to}T23:59:59.999+05:00`).toISOString();
  }
  return query;
}
/** The API sends `null` for absent values; the schemas model those as omitted. */
function withoutNulls(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(withoutNulls);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, entry]) => entry !== null)
        .map(([key, entry]) => [key, withoutNulls(entry)]),
    );
  }
  return value;
}
export const foodOrderApi = {
  async list(params: FoodOrderSearch, signal?: AbortSignal) {
    return foodOrderListSchema.parse(
      withoutNulls(
        await http.get<unknown>(`${path}/${params.scope}`, {
          baseURL,
          query: foodOrderQuery(params),
          ...(signal ? { signal } : {}),
        }),
      ),
    );
  },
  async detail(id: string, signal?: AbortSignal) {
    const response = foodOrderDetailSchema.parse(
      withoutNulls(
        await http.get<unknown>(`${path}/${encodeURIComponent(id)}`, {
          baseURL,
          ...(signal ? { signal } : {}),
        }),
      ),
    );
    if (!response.data?.order) throw new Error('Заказ не найден');
    return response.data.order;
  },
  async cancel(id: string, payload: CancelFoodOrder) {
    await http.post(`${path}/${encodeURIComponent(id)}/cancel`, payload, { baseURL });
  },
  async createTest(payload: CreateTestFoodOrder) {
    await http.post(
      `${path}/test`,
      {
        ...payload,
        product_id: payload.product_id === '' ? undefined : payload.product_id,
      },
      { baseURL },
    );
  },
};
